/**
 * Returns true when the sponsor ID matches the manufacturer sponsor pattern.
 * Pattern: "mfr" followed by one or more digits (e.g., "mfr123").
 */
export const isManufacturerSponsor = (sponsorId: string): boolean => {
  return new RegExp(/(mfr\d+)/).test(sponsorId);
};
